module.exports = __webpack_public_path__ + "img/11.6ae8b9ef.jpg";